import { Spinner } from "@shopify/polaris"
import { Editor } from "@tinymce/tinymce-react"
import React, { useState } from "react"
import "tinymce/tinymce.min.js"
import "tinymce/models/dom/model"
import "tinymce/themes/silver/theme.min.js"
import "tinymce/icons/default"
import "tinymce/skins/ui/oxide/skin"
import "tinymce/plugins/advlist"
import "tinymce/plugins/anchor"
import "tinymce/plugins/autolink"
import "tinymce/plugins/autoresize"
import "tinymce/plugins/autosave"
import "tinymce/plugins/charmap"
import "tinymce/plugins/code"
import "tinymce/plugins/codesample"
import "tinymce/plugins/directionality"
import "tinymce/plugins/emoticons"
import "tinymce/plugins/fullscreen"
import "tinymce/plugins/help"
import "tinymce/plugins/help/js/i18n/keynav/en"
import "tinymce/plugins/image"
import "tinymce/plugins/importcss"
import "tinymce/plugins/insertdatetime"
import "tinymce/plugins/link"
import "tinymce/plugins/lists"
import "tinymce/plugins/media"
import "tinymce/plugins/nonbreaking"
import "tinymce/plugins/pagebreak"
import "tinymce/plugins/preview"
import "tinymce/plugins/quickbars"
import "tinymce/plugins/save"
import "tinymce/plugins/searchreplace"
import "tinymce/plugins/table"
import "tinymce/plugins/visualblocks"
import "tinymce/plugins/visualchars"
import "tinymce/plugins/wordcount"
import "tinymce/skins/content/default/content"
import "tinymce/skins/ui/oxide/content"

export const DescriptionEditor = ({ onEdit, initialHTML }) => {
	const replaceImg = (html) => {
		return html.replace(
			/<img([^>]*)>/gi,
			`<img$1 referrerpolicy="no-referrer" style="max-width: 100%;">`,
		)
	}

	const [loading, setLoading] = useState(true)

	const handleEditorChange = (content, editor) => {
		onEdit(content)
	}

	const _initialHtml = initialHTML ? replaceImg(initialHTML) : null

	return (
		<>
			{loading && (
				<div
					style={{
						height: "31.25rem",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Spinner size="large"></Spinner>
				</div>
			)}
			<Editor
				license="gpl"
				initialValue={_initialHtml}
				init={{
					height: 500,
					menubar: false,
					plugins: [
						"advlist",
						"autolink",
						"lists",
						"link",
						"image",
						"charmap",
						"preview",
						"anchor",
						"searchreplace",
						"visualblocks",
						"code",
						"fullscreen",
						"insertdatetime",
						"media",
						"table",
						"help",
						"wordcount",
					],
					toolbar:
						"undo redo blocks bold italic underline forecolor alignleft aligncenter alignright alignjustify | \
						bullist numlist | outdent indent | \
						fontfamily fontsize | \
						code removeformat",
					referrer_policy: "no-referrer",
					extended_valid_elements:
						"img[src|style|referrerpolicy|width|height]",
				}}
				onEditorChange={handleEditorChange}
				onInit={() => setLoading(false)}
			/>
		</>
	)
}
